// @ts-nocheck
import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(
  ['WebformElementContainer'],
  (item, ctx) => {
    return {
      $el: 'div',
      children: ctx.buildChildren(item.element.items),
    }
  },
)
